import React from 'react';
import { motion } from 'framer-motion';
interface LoadingOverlayProps {
  message: string;
  subMessage?: string;
}
export function LoadingOverlay({
  message,
  subMessage
}: LoadingOverlayProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.3
  }} className="absolute inset-0 z-50 bg-slate-950/95 backdrop-blur-sm flex flex-col items-center justify-center px-8" data-id="element-1090">
      {/* Single AI-style orbiting ring + logo */}
      <div className="relative mb-10 flex items-center justify-center" style={{
      width: 120,
      height: 120
    }} data-id="element-1091">
        {/* Rotating gradient ring */}
        <motion.div animate={{
        rotate: 360
      }} transition={{
        repeat: Infinity,
        duration: 2.5,
        ease: 'linear'
      }} className="absolute inset-0" data-id="element-1092">
          <svg viewBox="0 0 120 120" className="w-full h-full" data-id="element-1093">
            <defs data-id="element-1094">
              <linearGradient id="ai-gradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-1095">
                <stop offset="0%" stopColor="#eab308" stopOpacity="0" data-id="element-1096" />
                <stop offset="40%" stopColor="#eab308" stopOpacity="0.05" data-id="element-1097" />
                <stop offset="70%" stopColor="#eab308" stopOpacity="0.4" data-id="element-1098" />
                <stop offset="100%" stopColor="#facc15" stopOpacity="1" data-id="element-1099" />
              </linearGradient>
            </defs>
            <circle cx="60" cy="60" r="54" fill="none" stroke="url(#ai-gradient)" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="240 100" data-id="element-1100" />
          </svg>
        </motion.div>

        {/* Subtle static track ring */}
        <div className="absolute inset-0" data-id="element-1101">
          <svg viewBox="0 0 120 120" className="w-full h-full" data-id="element-1102">
            <circle cx="60" cy="60" r="54" fill="none" stroke="rgba(234,179,8,0.06)" strokeWidth="2.5" data-id="element-1103" />
          </svg>
        </div>

        {/* Logo */}
        <motion.img src="https://cdn.magicpatterns.com/uploads/k8xXGBCxgczNy7w1RnYyrw/image.png" alt="BiltOn" className="h-9 w-auto relative z-10" initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15,
        duration: 0.4,
        ease: 'easeOut'
      }} data-id="element-1104" />
      </div>

      {/* Message */}
      <motion.p initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.4
    }} className="text-white font-semibold text-base text-center mb-1" data-id="element-1105">
        {message}
      </motion.p>
      {subMessage && <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.4
    }} className="text-slate-500 text-xs text-center" data-id="element-1106">
          {subMessage}
        </motion.p>}
    </motion.div>;
}